const BASE_URL = 'ai-service/api/selection-lists'

const selectionListsRequests = {
  getSelectionListsRequest: (data) => ({
    url: BASE_URL,
    method: 'get',
  }),
  getSelectionListByIdRequest: ({ selectionListId }) => ({
    url: `${BASE_URL}/${selectionListId}`,
    method: 'get',
  }),
  getSelectionListForEditByIdRequest: ({ selectionListId }) => ({
    url: `${BASE_URL}/${selectionListId}`,
    method: 'get',
  }),
  createSelectionListRequest: (data) => ({
    url: BASE_URL,
    method: 'post',
    data,
  }),
  updateSelectionListRequest: (data) => ({
    url: `${BASE_URL}/${data.Id}`,
    method: 'put',
    data,
  }),
  deleteSelectionListRequest: ({ id }) => ({
    url: `${BASE_URL}/${id}`,
    method: 'delete',
  }),
}

export default selectionListsRequests
